"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkset = void 0;
var react_1 = __importDefault(require("react"));
var SelectComponents_1 = require("./select/SelectComponents");
var useSelect_1 = require("./select/useSelect");
var Checkset = function (props) {
    var _a, _b, _c;
    var components = __assign(__assign({}, SelectComponents_1.defaultSelectComponents), props.components);
    var Container = components.Container, OptionContainer = components.OptionContainer, Option = components.Option;
    var _d = useSelect_1.useSelect(props), searchQuery = _d.searchQuery, onSearchChange = _d.onSearchChange, highlightedOption = _d.highlightedOption, setHighlightedOption = _d.setHighlightedOption, selectedOptions = _d.selectedOptions, onSelect = _d.onSelect, options = _d.options, setHighlightedEl = _d.setHighlightedEl, setSearchableInputEl = _d.setSearchableInputEl, onKeyDown = _d.onKeyDown, close = _d.close;
    var renderOption = function (option, index) {
        var isHighlighted = option === highlightedOption;
        var isSelected = selectedOptions.some(function (selectedOption) { return selectedOption.value === option.value; });
        var ref = isHighlighted ? setHighlightedEl : undefined;
        if (isSelected && props.hideOptionOnSelection) {
            return null;
        }
        return (react_1.default.createElement(OptionContainer, { ref: ref, isHighlighted: isHighlighted, isDisabled: option.disabled, onClick: function (e) {
                e.preventDefault();
                onSelect(option);
                close();
            }, onMouseEnter: function () { return setHighlightedOption(option); }, key: "select-option-" + index + "-" + option.value },
            react_1.default.createElement(Option, { multiple: props.multiple || false, option: option, isHighlighted: isHighlighted, isSelected: isSelected, isDisabled: option.disabled })));
    };
    var renderGroup = function (group) {
        if (!group.options || group.options.length === 0) {
            return null;
        }
        return __spreadArray([
            react_1.default.createElement("p", { className: "c-dropdown__group" }, group.heading)
        ], group.options.map(renderOption));
    };
    var renderOptions = function () {
        var optionsToRender = options
            .map(function (option, index) {
            if ("options" in option) {
                return renderGroup(option);
            }
            else {
                return renderOption(option, index);
            }
        })
            .filter(function (option) { return option !== null; });
        if (optionsToRender.length === 0) {
            return (react_1.default.createElement("div", { className: "u-align-center u-pad-small u-color-light" }, props.noOptionsText || "No options available"));
        }
        return optionsToRender;
    };
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement("div", { onKeyDown: onKeyDown, className: "l-app +y +gap-0 rc-checkset" },
            props.searchable && (react_1.default.createElement("div", { className: "l-app__item +start rc-checklist__filter" },
                react_1.default.createElement("input", { ref: setSearchableInputEl, onChange: onSearchChange, value: searchQuery, size: searchQuery.length || 1, type: "text", className: "c-input +fill +text", placeholder: ((_a = props.placeholderText) === null || _a === void 0 ? void 0 : _a.toString()) || "Type to filter" }))),
            react_1.default.createElement("div", __assign({}, props.selectionComponentProps, { className: "l-app__item +middle rc-checklist__options " + ((_c = (_b = props.selectionComponentProps) === null || _b === void 0 ? void 0 : _b.className) !== null && _c !== void 0 ? _c : "") }),
                react_1.default.createElement("ul", { className: "c-list rc-checklist__option-list", onMouseLeave: function () { return setHighlightedOption(undefined); } }, renderOptions())))));
};
exports.Checkset = Checkset;
//# sourceMappingURL=Checkset.js.map